<template>
    <form v-show="isInputFormActive" method="POST">
        <div class="row">
            <div class="col-lg-4 col-md-4 col-12">
                <div class="form-group">
                    <label for="itemname">{{ localizationStore.translate("credit.bureau") }}</label>
                    <select
                        v-model="selectedCreditBureauId"
                        @change="getCreditBureauList(selectedCreditBureauId)"
                        id="creditbureau"
                        name="creditbureau"
                        class="form-control"
                        :class="{'is-invalid' : creditBureauError}"
                        required
                    >
                        <option v-for="creditBureau in creditBureaus" v-bind:value="creditBureau.id">{{ creditBureau.name }}</option>
                    </select>
                    <span v-if="creditBureauError" class="invalid-feedback" role="alert">
                        <strong>Field is Required</strong>
                    </span>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-12">
                <div class="form-group">
                    <label>&nbsp;</label>
                    <br />
                    <button @click="submitForm" type="button" class="btn btn-outline-primary btn-submit"> Dispute Selected Items</button>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-12">
                <!-- search input -->
                <div class="custom-search d-flex justify-content-end">
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <div class="d-flex align-items-center">
                            <label class="mr-1">Search</label>
                            <input
                                v-model="searchTerm"
                                placeholder="Search"
                                type="text"
                                class="d-inline-block form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <vue-good-table
      v-show="isInputFormActive"
      ref="inquiry-table"
      v-on:selected-rows-change="creditorSelectionChanged"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :select-options="{
        enabled: true,
        disableSelectInfo: true,
        selectOnCheckboxOnly: true
      }"
    >
        <template #table-row="props">
            <span v-if="props.column.field === 'action'">
                <div class="d-flex align-items-center col-actions">
                    <a class="mr-1 text-primary" data-toggle="tooltip" data-placement="top" title="Individual Dispute">
                        <vue-feather type="send" @click="dispute(props.row.id)"></vue-feather>
                    </a>
                </div>
            </span>
        </template>
    </vue-good-table>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                            <form :action="routes.createLetterRoute" method="post" enctype="multipart/form-data">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" value="21" hidden>
                                <div class="col-md-12">
                                    <div id="editor">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="1">
                                            {{ localizationStore.translate("letter.left.submit.button.text") }}
                                        </button>
                                        <button
                                        class="btn btn-outline-primary ml-1"
                                        @click="$refs.spinner.spinLetter()" type="button">
                                        {{ localizationStore.translate("spin.letter.button.text") }}
                                        </button>
                                    </div>
                                
                                <div class="row">
                                    <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRef' />
                                </div>
                                </div>
                            </form>
                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRefSingle" hidden>
            <div class="page">
                <p>
                    Consumer Financial Protection Bureau
                    <br> Consumer Response Center
                    <br> P.O. Box 2900
                    <br> Clinton, IA 52733-2900
                    <br>
                    <br> Date: {{ date }}
                    <br>
                    <br> To Whom It May Concern:
                </p>
                <p class="letter-content">
                    This letter is a formal complaint against
                    <strong v-if="isCreditBureauSelected">{{ selectedCreditBureau.name }}</strong>.
                    They have repeatedly violated my rights and the Fair Credit Reporting Act. Despite the proof that I've sent to them, they continue reporting inaccurate and unverifiable derogatory information about me to potential creditors.
                </p>
                <p class="letter-content">
                    1. I have requested <strong>re-investigation</strong> and verification of items which they are reporting in my file. They claim to have verified these accounts but it's all electronic and therefore, they never even speak with anyone to conduct a “reasonable investigation” as mandated by law.
                </p>
                <p class="letter-content">
                    2. there are two accounts, in particular which they just refuse to investigate <strong>(Western Itl. Unv. Online and Asset Acceptance)</strong>, yet they turn around and tell me that these accounts were verified by the Creditor. However, I've contacted some of the creditors and they have no record of a dispute verification request from this or any other agency regarding an account for me.
                </p>
                <p v-if="selectedCreditor.length > 0">
                    <strong>NAME OF ACCOUNT:</strong> {{ selectedCreditor[0].furnisher_name }}
                    <br />
                    <template v-if="selectedCreditor[0].reference_number">
                        <strong>REFERENCE NUMBER: </strong>{{ selectedCreditor[0].reference_number }}<br />
                    </template>
                    <template v-else>
                        <strong>ACCOUNT NUMBER: </strong>{{ selectedCreditor[0].account_number }}<br>
                    </template>
                    <strong>PROVIDE PHYSICAL PROOF OF VERIFICATION: </strong>
                    UNVERIFIED ACCOUNT
                    <br />
                    <br />
                </p>
                <p class="letter-content">
                    3. I've actually disputed with Asset Acceptance several times directly who simply refuses to validate the debt they claim I owe as requested per the FDCPA. I'm even in dispute with them via the Better Business Bureau. And I've sent every piece of proof that both Experian and TransUnion could possibly need to correct this erroneous information on my credit report yet they refuse to do so.
                </p>
                <p class="letter-content">
                    That being said, I feel as though I am being fraudulently attacked by these credit reporting agencies and I also feel as though they are supporting the reporting of erroneous information on my credit files because they continue to report erroneous accounts on my credit report that should not be there and refusing to adhere to my rights of a reasonable re-investigation and proper verification of this account. Not to mention the fact that they're simply ignoring the proof that I've sent them.
                    <br>
                    <br>
                    I'm well aware of the thousands of other complaints against these agencies on a daily basis. So my question is, where does it stop? And does your commission know about the feature they have in their "electronic verification process" known as a "reply all" function which allows the creditor to verify an account without ever even looking at it and/or investigating it? It's right on their website! And if you do know about this, how in the world can you justify it?! Please investigate the credit reporting practices of this company. I'm requesting that this company is disciplined accordingly for their willful and blatant disregard for the law and also that REQUIRE them to remove the disputed accounts in question from my credit reports. This causes serious harm not only to my ability to establish credit and good interest rates, but also to my character as a Professional. If there's anything I can send you to support my claim, please do not hesitate to let me know. Thank you in advance for your immediate attention to this very serious matter.
                </p>
                <p> Sincerely,
                    <br>
                    <br> {{ userInfo.firstname }} {{ userInfo.lastname }}
                    <br /> {{ userInfo.address }}
                    <br /> {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                    <br> </p>
            </div>
        </div>
        <div ref="editorRefMultiple" hidden>
            <div class="page">
                <p>
                    Consumer Financial Protection Bureau
                    <br> Consumer Response Center
                    <br> P.O. Box 2900
                    <br> Clinton, IA 52733-2900
                    <br>
                    <br> Date: {{ date }}
                    <br>
                    <br> To Whom It May Concern:
                </p>
                <p class="letter-content">
                    This letter is a formal complaint against
                    <strong v-if="isCreditBureauSelected">{{ selectedCreditBureau.name }}</strong>.
                    They have repeatedly violated my rights and the Fair Credit Reporting Act. Despite the proof that I've sent to them, they continue reporting inaccurate and unverifiable derogatory information about me to potential creditors.
                </p>
                <p class="letter-content">
                    1. I have requested <strong>re-investigation</strong> and verification of items which they are reporting in my file. They claim to have verified these accounts but it's all electronic and therefore, they never even speak with anyone to conduct a “reasonable investigation” as mandated by law.
                </p>
                <p class="letter-content">
                    2. there are two accounts, in particular which they just refuse to investigate <strong>(Western Itl. Unv. Online and Asset Acceptance)</strong>, yet they turn around and tell me that these accounts were verified by the Creditor. However, I've contacted some of the creditors and they have no record of a dispute verification request from this or any other agency regarding an account for me.
                </p>
                <p>
                    <template v-for="creditor in selectedCreditor">
                        <strong>NAME OF ACCOUNT:</strong> {{ creditor.furnisher_name }}
                        <br />
                        <template v-if="creditor.reference_number">
                            <strong>REFERENCE NUMBER: </strong>{{ creditor.reference_number }}
                            <br />
                        </template>
                        <template v-else>
                            <strong>ACCOUNT NUMBER: </strong>{{ creditor.account_number }}
                            <br />
                        </template>
                        <strong>
                            Please Investigate and Verify the accuracy of this account with the Original Creditor.
                        </strong>
                        <br />
                        <br />
                    </template>
                </p>
                <p class="letter-content">
                    3. I've actually disputed with Asset Acceptance several times directly who simply refuses to validate the debt they claim I owe as requested per the FDCPA. I'm even in dispute with them via the Better Business Bureau. And I've sent every piece of proof that both Experian and TransUnion could possibly need to correct this erroneous information on my credit report yet they refuse to do so.
                </p>
                <p class="letter-content">
                    That being said, I feel as though I am being fraudulently attacked by these credit reporting agencies and I also feel as though they are supporting the reporting of erroneous information on my credit files because they continue to report erroneous accounts on my credit report that should not be there and refusing to adhere to my rights of a reasonable re-investigation and proper verification of this account. Not to mention the fact that they're simply ignoring the proof that I've sent them.
                    <br>
                    <br>
                    I'm well aware of the thousands of other complaints against these agencies on a daily basis. So my question is, where does it stop? And does your commission know about the feature they have in their "electronic verification process" known as a "reply all" function which allows the creditor to verify an account without ever even looking at it and/or investigating it? It's right on their website! And if you do know about this, how in the world can you justify it?! Please investigate the credit reporting practices of this company. I'm requesting that this company is disciplined accordingly for their willful and blatant disregard for the law and also that REQUIRE them to remove the disputed accounts in question from my credit reports. This causes serious harm not only to my ability to establish credit and good interest rates, but also to my character as a Professional. If there's anything I can send you to support my claim, please do not hesitate to let me know. Thank you in advance for your immediate attention to this very serious matter.
                </p>
                <p> Sincerely,
                    <br>
                    <br> {{ userInfo.firstname }} {{ userInfo.lastname }}
                    <br /> {{ userInfo.address }}
                    <br /> {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                    <br> </p>
            </div>
        </div>
    </section>
</template>
<script>
  import { reactive, computed, ref } from 'vue'
  import 'vue-good-table-next/dist/vue-good-table-next.css'
  import { VueGoodTable } from 'vue-good-table-next';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  export default {
    props: {
        csrf: {
            type: String
        },
        propCreditBureaus: {
            type: [Array, Object]
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
        VueGoodTable,
    },
    setup(props) {
        return {
            creditBureaus: props.propCreditBureaus,
            selectedCreditBureauId: ref(props.propCreditBureaus[0].id),
            editorRefSingle: ref(null),
            editorRefMultiple: ref(null),
            isInputFormActive: ref(true),
            creditBureauError: ref(false),
            date: ref(null),
            editorRef: ref(null),
            localizationStore: useLocalizationStore()
        };
    },
    data(){
        const selectedCreditor = reactive([]);
        return {
          columns: [
            {
              label: 'CREDITOR',
              field: 'furnisher_name',
            },
            {
              label: 'ACCOUNT NUMBER',
              field: 'account_number',
            },
            {
              label: 'PAYMENT STATUS',
              field: 'payment_status',
            },
            {
              label: 'Action',
              field: 'action',
            }
          ],
          rows: [],
          searchTerm: '',
          selectedCreditor
        };
    },
    created() {
        // console.log(this.creditBureaus);
    },
    mounted() {
        axios.get(this.routes.currentDate).then(response => (this.date = response.data));
        this.getCreditBureauList(this.selectedCreditBureauId);
    },
    computed: {
        // a computed getter
        selectedCreditBureau() {
            return this.creditBureaus.find((attribute) => {
                if (attribute.id == this.selectedCreditBureauId) {
                    return attribute;
                }
            })
        },
        isCreditBureauSelected() {
            return (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") ? false : true;
        }
    },
    methods: {
      submitForm: function () {
        if (this.validate()) {
            this.editorRef = this.editorRefMultiple;
            this.selectedCreditor = this.$refs['inquiry-table'].selectedRows;
            tinymce.get('editor').setContent(this.editorRefMultiple.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }
      },
      dispute: function (id) {
        this.selectedCreditor[0] = this.rows.find((attribute) => {
            if (attribute.id == id) {
                return attribute;
            }
        });
        this.editorRef = this.editorRefSingle;
        setTimeout(() => {
            tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }, "100");
      },
      goBack: function () {
        this.isInputFormActive = !this.isInputFormActive;
      },
      validate: function () {
        if (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") {
            this.creditBureauError = true;
        }
        else {
            this.creditBureauError = false;
        }
        return !this.creditBureauError;
      },
      getCreditBureauList: function (type) {
        axios.get(this.routes.listCreditBureau.replace(':type', type)).then(response => {
                this.rows = response.data.data
            }
        );
      },
      creditorSelectionChanged: function (params) {
        this.selectedCreditor = params.selectedRows;
      }
    }
  };
</script>
